module.exports = __webpack_public_path__ + "static/media/logo-odonto.279a97aa.svg";